<template>
    <path
        fill="none"
        stroke="currentColor"
        stroke-width="1.5"
        d="M13.606 6.235a1.999 1.999 0 0 1 0 3.529L5.064 14.409C3.689 15.158 2 14.185 2 12.645V3.355c0-1.54 1.689-2.513 3.064-1.765z"
    />
</template>
